
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1039.342 1189.857"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 22","d":"M1034.071 904.887a22.324 22.324 0 005.271-14.187v-.561l-5.383-583.057a6.777 6.777 0 00-.056-1.065v-.112a22.477 22.477 0 00-1.962-7.963c0-.056 0-.056-.056-.112v-.224c-.224-.5-.505-1.009-.785-1.514q-.589-1.009-1.177-1.85v-.172a22 22 0 00-5.944-5.664.055.055 0 01-.056-.056 10.426 10.426 0 00-1.065-.617L527.943 2.482a.055.055 0 01-.056-.056 22.055 22.055 0 00-3.084-1.458h-1.572a22.716 22.716 0 00-2.636-.673h-.842a22.414 22.414 0 00-13.962 2.243h-.168s0 .056-.056 0a.055.055 0 00-.056.056c-.225.112-.393.224-.617.336l-.056.056L20.187 284.649l-.841.5h-.056a22.337 22.337 0 00-10.262 17.607 5.442 5.442 0 01-.056.953L.001 884.476V885.989a21.713 21.713 0 002.411 8.8v.392a22.241 22.241 0 003.589 4.935l.056.056.056.056v.112l.056.056.056.056a20.185 20.185 0 002.916 2.411s.056.056.056 0h.281a7.832 7.832 0 00.9.561c.224.168.5.28.729.449l499.959 283.064a22.391 22.391 0 009.533 2.86h.337c.449 0 .841.056 1.29.056-.004.004 511.06-284.012 511.845-284.966zm-511.455 230.074zm447.81-244.316l-331.175 185.774zm-569.715 181.961L69.367 884.982zm589.678-616.37l3.645 396.165zM45.647 846.85l6.056-391.007zm937.62-523.735zm-923.713-3.533zM538.822 60.631l320.073 184.485zM181.179 242.593L493.962 60.8z","fill":"#fff"}})])
          )
        }
      }
    